/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';

export const finalizeCrSeries = (
  points: ReadonlyArray<CommonChartData>,
  yesterdayIndex: number,
): CommonChartData[] => {
  const history = points
    .slice(0, Math.max(0, yesterdayIndex + 1))
    .map(p => p.primary)
    .filter(v => typeof v === 'number' && Number.isFinite(v)) as number[];

  const hasHistory = history.length > 0;
  const histMin = hasHistory ? Math.min(...history) : undefined;
  const histMax = hasHistory ? Math.max(...history) : undefined;

  const clamp = (value: number): number => {
    if (!hasHistory) return value;
    return Math.min(Math.max(value, histMin as number), histMax as number);
  };

  const clampRange = (range?: Readonly<[number, number]>): [number, number] | undefined => {
    if (!range) return undefined;
    return [clamp(range[0]), clamp(range[1])];
  };

  return points.map((p, idx) => {
    if (idx <= yesterdayIndex) return p;

    if (!p.average && p.range) {
      const nextRange = clampRange(p.range)!;
      const nextAverage = (nextRange[0] + nextRange[1]) / 2;
      return {...p, average: nextAverage, range: nextRange};
    }

    if (p.average === undefined && p.range === undefined) {
      const base = points[yesterdayIndex];
      const avg = clamp(base.primary ?? 0);
      return {...p, average: avg, range: [avg, avg]};
    }

    if (p.average !== undefined || p.range) {
      const nextAverage = p.average !== undefined ? clamp(p.average as number) : p.average;
      const nextRange = clampRange(p.range);
      return {
        ...p,
        ...(nextAverage !== undefined ? {average: nextAverage} : {}),
        ...(nextRange ? {range: nextRange} : {}),
      };
    }

    return p;
  });
};
